export interface MLCuttingParams {
  fz: number;
  ap: number;
  ae: number;
  vc: number;
  nbDents: number;
  diameterCut: number;
}

export const ML_CUTTING_DEFAULTS: MLCuttingParams = {
  fz: 0.04,
  ap: 2,
  ae: 1.5,
  vc: 120,
  nbDents: 3,
  diameterCut: 2,
};

export interface MLMachineSummary {
  id: number;
  name: string;
  brand: string;
  model: string;
  kafkaName?: string;
}

export interface MLProcessSummary {
  id: number;
  name: string;
  toolReference: string;
  processType: 'standard' | 'test';
  ae: number | null;
  ap: number | null;
  vc: number | null;
  fz: number | null;
}

export interface MLToolSummary {
  toolId: string;
  reference: string | null;
  lastUsedAt: string | null;
  status: 'in-use' | 'idle' | 'scrapped';
}

/**
 * The orchestrator resolves the machine's signal source and reads the tool's traced volume
 * itself; the worker reads the last 50 passes of the machine's newest part.
 */
export interface MLInferenceRequest {
  machineId: number;
  toolId: string;
  fz: number;
  ap: number;
  ae: number;
  vc: number;
  nbDents: number;
  diameterCut: number;
  /** Display context persisted with the server-side run record. */
  machine?: string;
  processId?: number;
  processName?: string;
}

/** What a live prediction read: the part, its passes and the tool's traced volume. */
export interface MLSignalsWindow {
  partId: string | null;
  passCount: number | null;
  /** ISO instants of the first pass start and the last pass end. */
  start: string | null;
  end: string | null;
  /** cm³, sum of the tool's traces. */
  volumeRemoved: number | null;
}

export interface MLInferenceResult {
  rulSeconds: number;
  warning?: string;
  window?: MLSignalsWindow;
}

export interface MLInferenceJobResult {
  jobId: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  timestamp: string;
  result?: MLInferenceResult;
  message?: string;
}

// Signal types (MLSignalChannel/Pass/Payload/Query) now live in the signals
// feature (src/features/signals/type/SignalsTypes.ts) — the ML feature
// imports SignalsChannel/SignalsPass/SignalsSeriesPayload/SignalsQuery from
// there instead of duplicating them here.

